import createExplicitLogonRequest from './createExplicitLogonRequest';
import { assertNever } from 'owa-assert';
import { MailboxInfo, MailboxType, getUserMailboxInfo } from 'owa-client-ids';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { getOWAConnectedAccount } from 'owa-accounts-store';
import { isPastTime } from 'owa-observable-datetime';
import { lazyGetAndUpdateRefreshToken } from 'owa-headers-refresh-token';
const HEADER_ANCHOR_MAILBOX: string = 'X-AnchorMailbox';
const HEADER_AUTHORIZATION: string = 'Authorization';

export default async function getDefaultRequestOptions(
    mailboxInfo: MailboxInfo
): Promise<RequestOptions | null> {
    if (mailboxInfo) {
        switch (mailboxInfo.type) {
            case MailboxType.GroupMailbox:
                return createExplicitLogonRequest(mailboxInfo.deprecatedMailboxId, mailboxInfo);
            case MailboxType.UserMailbox:
                let defaultRequestOptions = mailboxInfo.requestOptions;
                if (!defaultRequestOptions) {
                    defaultRequestOptions = {
                        headers: new Headers(),
                    };
                }

                // for all non-primary, connected accounts, get the token and anchor mailbox from owa-accounts-store
                if (mailboxInfo.primarySmtpAddress != getUserMailboxInfo().primarySmtpAddress) {
                    defaultRequestOptions.headers = await getHeadersForConnectedAccount(
                        mailboxInfo.primarySmtpAddress
                    );
                    defaultRequestOptions.authNeededOnUnAuthorized = false;
                }
                return defaultRequestOptions;
            default:
                return assertNever(mailboxInfo.type);
        }
    } else {
        return null;
    }
}

export async function getHeadersForConnectedAccount(primarySmtpAddress: string): Promise<Headers> {
    let headers = new Headers();
    const account = getOWAConnectedAccount(primarySmtpAddress);
    if (account) {
        let token = account.token;

        headers.append(HEADER_ANCHOR_MAILBOX, account.anchorMailbox);

        if (isPastTime(account.tokenExpiry)) {
            token = await lazyGetAndUpdateRefreshToken.importAndExecute(account.accountId);
        }

        const tokenString = `MSAuth1.0 usertoken="${token}", type="MSACT"`;
        headers.append(HEADER_AUTHORIZATION, tokenString);
    }

    return headers;
}
